module.exports = __webpack_public_path__ + "images/help/video-invite-0e41ade10c77487f6d5b80c27ea89f15.png";